import React from "react";

import SlideRealisation from "../../components/slideRealisation";
import RealisationListe from "../../components/realisationListe";
import Newsletter from "../../components/newsletter";

const RealisationPage = () => {
  return (
    <div>
      <SlideRealisation />
      <RealisationListe />
      <Newsletter />
    </div>
  );
};

export default RealisationPage;
